import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND}/api` });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem("vf_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const adminApi = axios.create({ baseURL: `${BACKEND}/api/admin`, withCredentials: true });

export const imgUrl = (p) => (p && p.startsWith("/api/") ? `${BACKEND}${p}` : p);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  if (Array.isArray(d)) return d[0]?.msg || "Invalid input";
  return "Something went wrong. Please try again.";
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const STATUS_LABEL = {
  placed: "Placed", confirmed: "Confirmed", packed: "Packed",
  out_for_delivery: "Out for delivery", delivered: "Delivered", cancelled: "Cancelled",
};
export const STATUS_FLOW = ["placed", "confirmed", "packed", "out_for_delivery", "delivered"];
export const PAY_METHOD = { cod: "Cash on delivery", upi_delivery: "UPI at delivery", bank_transfer: "Bank transfer" };
export const PAY_STATUS = {
  due_on_delivery: "Pay on delivery", awaiting_proof: "Awaiting payment proof",
  proof_submitted: "Proof submitted · under review", verified: "Payment verified",
  rejected: "Payment rejected", paid: "Paid",
};
export const REFUND_STATUS = {
  none: "No refund", adjusted: "Deducted from amount due", pending: "Refund pending", completed: "Refunded",
};
